const LIVE_STREAM_PATH = '/api/v1/market-data/live-stream';

export const trimTrailingSlashes = (value) => String(value || '').replace(/\/+$/, '');

export const fallbackDevelopmentWebSocketBase = () => {
  if (typeof window === 'undefined' || !window.location?.origin) return 'ws://localhost:3000';
  return window.location.origin.replace(/^http/i, 'ws');
};

export const getWebSocketBase = () => {
  const configuredBase = trimTrailingSlashes(process.env.REACT_APP_WEBSOCKET_BASE);
  if (configuredBase) return configuredBase;
  if (process.env.NODE_ENV === 'production') {
    throw new Error('REACT_APP_WEBSOCKET_BASE is required for production WebSocket builds.');
  }
  return trimTrailingSlashes(fallbackDevelopmentWebSocketBase());
};

export const buildLiveStreamWebSocketUrl = (jwt) => {
  if (!jwt) throw new Error('A JWT is required to open the live market-data stream.');
  return `${getWebSocketBase()}${LIVE_STREAM_PATH}?token=${encodeURIComponent(jwt)}`;
};

export { LIVE_STREAM_PATH };
